import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';
import { Image, CTA } from '../../';

const BranchHero = ({ data, sponsor, className }) => {
	return (
		<div className={`branchHero grid grid-cols-1 md:grid-cols-2 md:grid-rows-1 ${className || ''}`}>
			{data.image?.[0] && (
				<Image
					data={data.image[0]}
					loading='eager'
					className='col-span-full row-start-1 aspect-[2.5/1] w-full md:h-full xl:max-h-[670px]'
				/>
			)}

			<div className='branchHero-content relative col-span-full self-center bg-gray-90/80 md:row-start-1 md:bg-transparent md:py-6'>
				<Container>
					<div className={`py-6 md:w-3/5 md:bg-gray-90/80 md:px-6 xl:w-6/12 xl:p-8 ${data.text_position === 'right' ? 'md:ml-auto' : ''}`}>
						{data.heading && (
							<h1
								className='mb-0 text-32px font-light text-white xl:text-42px [&_a]:text-white [&_a]:decoration-current'
								dangerouslySetInnerHTML={{ __html: data.heading }}
							/>
						)}
						{data.description && (
							<div
								className='mt-3 text-lg !leading-snug text-white md:text-xl xl:mt-5 xl:text-26px [&_a]:text-white [&_a]:decoration-current'
								dangerouslySetInnerHTML={{ __html: data.description }}
							/>
						)}
						{data.cta?.[0] && (
							<CTA
								size='sm'
								data={data.cta[0]}
								className='mt-4 md:min-w-[272px] xl:mt-6'
							/>
						)}
					</div>
					{sponsor && (
						<div className={`branch-hero-sponsorship -mx-6 flex items-center justify-center gap-x-2.5 bg-white px-6 py-2.5 md:mx-0 md:w-3/5 lg:hidden ${data.text_position === 'right' ? 'md:ml-auto' : ''}`}>
							{sponsor.logo?.url && (
								<Image
									data={{ image: sponsor.logo }}
									className='h-12 w-[66px] flex-none md:h-[37px] md:w-[51px] [&_img]:!object-contain'
								/>
							)}

							{sponsor.description && (
								<div
									dangerouslySetInnerHTML={{ __html: sponsor.description }}
									className='max-w-[30ch] flex-1 text-xs font-semibold tracking-0.25px text-black'
								/>
							)}
						</div>
					)}
				</Container>
			</div>
		</div>
	);
};

BranchHero.propTypes = {
	data: PropTypes.object.isRequired,
	sponsor: PropTypes.object,
	className: PropTypes.string,
};

export default BranchHero;
